import { brandInfo } from "../../../constant";
import { useElement } from "../../../hooks";
import { secureIndex } from "./constants";
import { SecureItem } from "./SecureItem";
import "./style.scss";

export const SecureSection = () => {
  const Img = useElement("Img");
  return (
    <section className="secure-sec mb60-mbs40">
      <div className="jumbo-container">
        <div className="wrapper">
          <div className="main-secure">
            <div className="why-carmitra">
              <h2 className="heading-02">
                Why to choose {brandInfo.name.capital}?
              </h2>
            </div>
            {secureIndex.map((item, index) => (
              <SecureItem
                key={index}
                index={index}
                title={item.title}
                content={item.content}
              />
            ))}
          </div>
          <Img src="secure-tiles.jpg" />
        </div>
      </div>
    </section>
  );
};
